<template>
    <span>
        <Unauthenticated v-if="!authenticated" />
        <Authenticated v-if="authenticated" />
    </span>
</template>

<script>
    import Unauthenticated from './layout/Unauthenticated'
    import Authenticated from './layout/Authenticated'

    export default {
        name: 'app',

        // ╔═╗╔═╗╔╦╗╔═╗╔═╗╔╗╔╔═╗╔╗╔╔╦╗╔═╗
        // ║  ║ ║║║║╠═╝║ ║║║║║╣ ║║║ ║ ╚═╗
        // ╚═╝╚═╝╩ ╩╩  ╚═╝╝╚╝╚═╝╝╚╝ ╩ ╚═╝

        components: {
            Unauthenticated,
            Authenticated
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Retorna um boolean para ver se o usuário está autenticado
             */
            authenticated () {
                return this.$store.state.authenticated
            }
        }
    }
</script>

<style lang="stylus">

    @import './assets/stylus/variables.styl'

    body
        background #f5f5f5 !important
        font-family $fontFamily !important

        .is-left
            text-align left

        .is-center
            text-align center

        .is-right
            text-align right

        .float-right
            float right

        .hidden-mobile
            display none

        .visible-mobile
            display inline-block

        a
            outline none

        .mu-title
            margin-top 10px

        .mu-breadcrumbs
            margin-bottom 10px
            display none

        .mu-button-float-right
            float right
            margin-left 10px

        .mu-table-header
            background #ddd

        .mu-table
            thead
                tr
                    height 38px
                th
                    height 28px

        .box-table-empty
            padding 40px 10px
            text-align center

        .menu-desktop
            display none

        .menu-mobile
            float right

        .mu-list.mu-list-custom
            padding 0
            border-radius 0
            .mu-item
                height 40px
                .mu-item-title
                    font-size 13px

    .mu-badge
        padding 2px 8px
        font-size 11px

    .mu-table-custom
        border-border-collapse collapse
        tr, th
            color darken($grey, 30%)
            a
                color darken($grey, 40%)
                text-decoration underline
                &:hover
                    color darken($grey, 80%)
        thead
            background #f5f5f5
            th
                font-weight bold
                text-transform uppercase

    .dialog-users
        .mu-dialog
            .mu-dialog-title
                padding 10px 20px
                background #dedede
            .mu-dialog-body
                padding 0 !important

    /* Tablet >= 768 pixels  */
    @media (min-width: 768px)

        body

            .hidden-mobile
                display inline-block

            .visible-mobile
                display none

            .mu-breadcrumbs
                display flex

            .menu-desktop
                display block

            .menu-mobile
                display none

    /* Formatação dos icons */
    .icon-margin-bottom
        margin-bottom 5px

    .icon-margin-left
        margin-right 10px
    .icon-margin-right
        margin-left 10px

    .icon-margin-top
        margin-top 5px;

    .icon-md
        font-size: 15px

    .icon-lg
        font-size: 20px

    .icon-big
        font-size: 30px

    .icon-big-extra
        font-size: 50px

    .color-primary
       color #8a2c8a

    .color-red
        color red

    .color-yellow
        color #ffbc33

    .color-green{
        color rgb(67, 160, 71)
    }
</style>
